<template>
    <div>
      <div class="scores"><div id="correctCount">{{ correctCount }}</div> +  <div id="incorrectCount">{{ errorCount }} </div> = <div id="total">{{ totalAnswered }}</div></div>
      <b-container class="" style="font-size:1.5rem;cursor:pointer;">
        <b-row v-for="(answer, index) in answers" :key="index" align-v="start" style="align-self:center; flex-basis:100%;margin-bottom:20px;" @click="() =>{ if (!isAnswerButtonDisabled) {answerQuestion(index)}}">
         <div style="width:3rem"><img style="width:2rem" v-if="isAnswerButtonDisabled && (selectedIndexInAnswers == index || index == questionIndexInAnswers)" :src="(questionIndexInAnswers == index)? 'img/check.png' : 'img/cross.png' "/></div>
          <div style="padding-right:10px;color:black;" v-for="(note, index) in answer" :key="index" class='radio'>{{ note.solfege }}</div>
        </b-row>
      </b-container>
      <button class="btn btn-light note" @click="playQuestion">Play</button>
      <!-- <button class="btn btn-primary note" :disabled="isAnswerButtonDisabled" @click="answerQuestion">Answer</button> -->
      <button id="nextButton" class="btn btn-primary note" :disabled="isNextButtonDisabled" @click="nextQuestion">Next</button>
    </div>
</template>

<script>
export default {
  name: 'ScaleQuiz',
  data () {
    return {
      correctCount: 0,
      errorCount: 0,
      totalAnswered: 0,
      question: [],
      answers: [],
      questionIndexInAnswers: null,
      selectedIndexInAnswers: null,
      isAnswerButtonDisabled: true,
      isNextButtonDisabled: false
    }
  },
  props: {
    notes: Array,
    playNote: Function,
    lengthOfEachQuestion: {
      type: Number,
      default: 3
    },
    totalQuestions: {
      type: Number,
      default: 5
    },
    numberOfAnswers: {
      type: Number,
      default: 3
    }
  },

  // Don't use arrow function for lifecycle hooks,
  // arrow functions use lexical this determined by their contexts and
  // vue won't be able to bind it for us.
  mounted () {
    this.nextQuestion()
  },
  methods: {
    answerQuestion (index) {
      this.totalAnswered += 1
      this.isAnswerButtonDisabled = true
      this.selectedIndexInAnswers = index

      if (this.questionIndexInAnswers === this.selectedIndexInAnswers) {
        this.correctCount++
        this.isNextButtonDisabled = true
        setTimeout(function () { const btn = document.querySelector('#nextButton'); btn.disabled = false; btn.click() }, 1000)
      } else {
        this.errorCount++
        this.isNextButtonDisabled = false
      }
    },
    async nextQuestion () {
      // generate answers
       // eslint-disable-line 
      // eslint-disable-next-line
      // debugger;
      this.isAnswerButtonDisabled = false
      this.isNextButtonDisabled = true
      this.answers = []
      for (let i = 0; i < this.numberOfAnswers; i++) {
        const tmp = []
        for (let j = 0; j < this.lengthOfEachQuestion; j++) {
          const randomIndx = Math.floor(Math.random() * this.notes.length)
          tmp.push(this.notes[randomIndx])
        }
        this.answers.push(tmp)
      }
      this.questionIndexInAnswers = Math.floor(Math.random() * this.numberOfAnswers)
      this.question = this.answers[this.questionIndexInAnswers]
      this.selectedIndexInAnswers = null
      this.playQuestion()
    },
    playNoteAndWait (frequency, solfege, duration) {
      return new Promise((resolve) => {
        this.$props.playNote(frequency, solfege, duration)
        setTimeout(resolve, duration + 200)
      })
    },
    async playQuestion () {
      for (const note of this.question) {
        await this.playNoteAndWait(note.frequency, note.solfege, 500)
      }
    }
  }
}
</script>

<style scoped>
 .scores {
   display: flex;
   justify-content: center;
   flex: 1 0 33.33%;
   color: black;
   margin-bottom:30px;
 }

 .container {
   display:flex;
   flex-direction: column;
   width:100%;
   align-items:center;
   justify-content: center;
 }

 .note {
   margin-top: 2rem;
   margin-right: 1rem;
 }
 #correctCount {
   color: green;
   margin-right:10px;
 }
 #incorrectCount {
   color: red;
   margin-left:10px;
   margin-right:10px;
 }
 #total {
   margin-left:10px;
 }
</style>
